<input
  #searchInput
  type="text"
  class="form-control"
  placeholder="Search Customer"
  [formControl]="searchControl"
  (focus)="onFocus()"
  (blur)="onBlur()"
/>

<button
  type="button"
  class="btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y me-2"
  style="z-index: 1010"
  (mousedown)="clearInput()"
>
  <i class="fa fa-times"></i>
</button>
@if (showDropdown() || isLoading()) {
<ul class="list-group position-absolute w-100" style="z-index: 2000">
  @if (isLoading()) {
  <li class="list-group-item list-group-item-action opacity-50">
    <span
      class="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true"
    ></span>
    Searching...
  </li>
  } @for (option of options; track option.id) {
  <li
    class="list-group-item list-group-item-action"
    (click)="selectOption(option)"
  >
    {{ option.name }}
  </li>
  }
</ul>
}
